import Modal from "../../components/Modal";
import { useAuthorizationExportForm } from "../hooks/useAuthorizationExportForm";
import { AUTHORIZATION_EXPORT_FIELDS } from "../utils/authorizationExportForm";

const AuthorizationExportModal = ({
  exporting = false,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const {
    errors,
    formValues,
    hasErrors,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
  } = useAuthorizationExportForm({ isOpen, onSubmit });

  const handlePrimaryClick = async () => {
    const submitted = await handleSubmit();
    if (submitted) onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Xuất file giấy ủy quyền"
      onClose={onClose}
      bodyClassName="p-6"
      maxWidth="520px"
      primaryButtonText={exporting ? "Đang xuất..." : "Xuất file"}
      primaryButtonOnClick={handlePrimaryClick}
      primaryButtonDisabled={hasErrors}
      isLoading={exporting}
      cancelButtonText="Hủy"
    >
      <div className="space-y-4">
        {AUTHORIZATION_EXPORT_FIELDS.map((field) => {
          const error = touched[field.key] ? errors[field.key] : "";

          return (
            <label key={field.key} className="block">
              <span className="mb-1.5 block text-sm font-sf-medium text-gray-700">
                {field.label}
              </span>
              <input
                value={formValues[field.key]}
                onBlur={() => handleBlur(field.key)}
                onChange={(event) => handleChange(field.key, event.target.value)}
                placeholder={field.placeholder}
                inputMode={field.inputMode}
                pattern={field.pattern}
                aria-invalid={Boolean(error)}
                className={`h-11 w-full rounded-lg border px-3 text-sm text-gray-800 outline-none transition-colors placeholder:text-gray-400 focus:ring-2 ${
                  error
                    ? "border-red-400 focus:border-red-500 focus:ring-red-500/20"
                    : "border-gray-200 focus:border-[#0457C2] focus:ring-[#0457C2]/20"
                }`}
              />
              {error && (
                <span className="mt-1 block text-sm font-sf-medium text-red-600">
                  {error}
                </span>
              )}
            </label>
          );
        })}
      </div>
    </Modal>
  );
};

export default AuthorizationExportModal;
